import { systemStatusTypes } from '@twiliointernal/services-common/components/systemStatus';

const copy = {
  errors: {
    unauthorized: {
      heading: 'You don’t have access to this page',
      description:
        'Access is to this page is restricted. Contact your admin, then try again.',
      link: 'Back to home page',
    },
    unauthenticated: {
      heading: "You haven't logged in yet",
      description:
        "You need to log in to access this page. Once you have, come back and we'll be able to help you out.",
      link: 'Back to home page',
    },
  },
  footer: {
    copyright: 'Copyright © 2023 Twilio Inc.',
    allRightsReserved: 'All Rights Reserved.',
    reCaptcha: {
      protectedByGoogle: 'This site is protected by reCAPTCHA and the Google ',
    },
  },
  otherSystemStatuses: {
    detailsLabel: 'Other system status details',
    heading: 'Other statuses',
    label: 'View other system statuses',
    segment: 'Segment status page',
    sendGrid: 'SendGrid status page',
    zipwhip: 'Zipwhip status page',
    iconTitles: {
      sendGrid: 'SendGrid',
      segment: 'Segment',
      zipwhip: 'Zipwhip',
    },
  },
  sidebar: {
    header: {
      label: 'Twilio Help Center',
      title: 'Go to Twilio Help Center',
    },
    collapseButton: {
      collapseLabel: 'Close sidebar',
      expandLabel: 'Open sidebar',
    },
    nav: {
      ariaLabel: 'Help Center Navigation',
      submitTicket: 'Submit a ticket',
      supportPlans: 'Support plans',
      ticketHistory: 'Ticket history',
    },
  },
  systemStatuses: {
    heading: 'System status',
    twilioStatusHeading: 'Twilio status',
  },
  topbar: {
    aiNavButton: 'Ask AI',
    accountSwitcher: {
      ariaLabel: 'Accounts',
      buttonLabel: 'Change account',
      error: 'Something went wrong. Try again later.',
      menuGroupLabel: 'Recent accounts',
      switchedAccountNotification: (accountName: string): string =>
        `Your active account has switched to ${accountName}.`,
      switchToMainAccountButtonLabel: 'Switch to main account',
      viewAllAccounts: 'View all accounts',
      viewAllSubaccounts: 'View all subaccounts',
    },
    supportPlan: {
      ctaValue: 'Explore other plans',
      detailsLabel: 'My support plan details',
      detailsHeading: (currentPlan: string): string =>
        `You are on a ${currentPlan} Plan`,
      label: 'My support plan',
      phoneSupportLabel: 'Phone support',
      planIncludes: 'This plan includes:',
      planExcludes: 'This plan does not include:',
      webSupportLabel: 'Web support',
      error: {
        ctaValue: 'View support plans',
        description: `Try reloading the page or 'View support plans'`,
        heading: 'System status summary info could not be loaded',
        menuValue: 'Failed to load data',
      },
    },
    switchProductsButton: 'Switch products',
    systemStatusButton: 'System status',
    systemStatus: {
      buttonError: (warningCount: number, errorCount: number): string =>
        `${warningCount ? `${warningCount} degraded` : ''}${
          warningCount && errorCount ? ', ' : ''
        } ${
          errorCount ? `${errorCount} outage${errorCount > 1 ? 's' : ''}` : ''
        }`,
      ctaValue: 'View detailed statuses',
      detailsLabel: 'System status details',
      headingError: (warningCount: number, errorCount: number): string =>
        `${
          warningCount
            ? `${warningCount} system${warningCount > 1 ? 's' : ''} degraded`
            : ''
        }${warningCount && errorCount ? ' and ' : ''} ${
          errorCount ? `${errorCount} outage${errorCount > 1 ? 's' : ''}` : ''
        }`,
      headingSuccess: 'All systems operational',
      heading: 'System status',
      label: 'Twilio system status',
      statusHeadings: {
        [systemStatusTypes.SystemStatusTypes.success]: 'Operational',
        [systemStatusTypes.SystemStatusTypes.warning]: 'Degraded',
        [systemStatusTypes.SystemStatusTypes.error]: 'Outage',
      },

      error: {
        ctaValue: 'View detailed status',
        description: `Try reloading the page or 'View detailed status'`,
        heading: 'System status summary info could not be loaded',
        menuValue: 'Failed to load data',
      },
    },
    userDialog: {
      name: 'User Profile',
      actions: 'User menu actions',
      logout: 'Logout',
    },
  },
  unauthenticatedHeader: {
    console: 'Console',
    login: 'Login',
    signUp: 'Sign up',
    title: 'Help Center',
  },
};

export default copy;
